import { type OutgoingWireTransferCreationResult } from "@finway-group/shared/lib/models/wallet/verificationOfPayee.enum"
import { type UpdateOwtPayeeReq, type UpdateOwtPayeeRes } from "@finway-group/shared/lib/models/wallet/wallet.api"
import axios from "axios"

const MODEL = "wallet"

export const WalletService = {
    fetchWalletDetails: async () => {
        const { data } = await axios.get(`/${MODEL}`)
        return data
    },
    fetchWalletFundingHistory: async () => {
        const { data } = await axios.get(`/${MODEL}/funding`)
        return data
    },
    fetchAccountStatements: async () => {
        const { data } = await axios.get(`/${MODEL}/statements`)
        return data
    },
    fetchAccountStatementById: async (id: string) => {
        const { data } = await axios.get(`/${MODEL}/statements/${id}`)
        return data
    },
    regenerateAccountStatement: async (id: string) => {
        const { data } = await axios.put(`/${MODEL}/statements/${id}`)
        return data
    },
    generateOutstandingAccountStatements: async () => {
        const { data } = await axios.post(`/${MODEL}/statements/outstanding`)
        return data
    },
    regenerateAllAccountStatements: async () => {
        const { data } = await axios.post(`/${MODEL}/statements`)
        return data
    },
    executeOutgoingWireTransfer: async (transferData: any): Promise<OutgoingWireTransferCreationResult> => {
        const { data } = await axios.post(`/${MODEL}/wire/`, transferData)
        return data
    },
    verifyOutgoingWireTransfer: async (wireTransferId: string, verificationCode: string) => {
        const { data } = await axios.post(`/${MODEL}/wire/verify`, { wireTransferId, verificationCode })
        return data
    },
    updateOutgoingWireTransferPayee: async (wireTransferId: string, payeeUpdate: UpdateOwtPayeeReq) => {
        const { data } = await axios.patch<UpdateOwtPayeeRes>(`/${MODEL}/wire/${wireTransferId}/payee`, payeeUpdate)
        return data
    },
    confirmOutgoingWireTransfer: async (wireTransferId: string): Promise<{ wireTransferId: string; isChallenged: boolean }> => {
        const { data } = await axios.post(`/${MODEL}/wire/${wireTransferId}/confirm`)
        return data
    },
    cancelOutgoingWireTransfer: async (wireTransferId: string) => {
        const { data } = await axios.post(`/${MODEL}/wire/${wireTransferId}/cancel`)
        return data
    },
    checkUserAuthenticationFactor: async () => {
        const { data } = await axios.get(`/${MODEL}/authfactor/check`)
        return data
    },
    enrollUserAuthenticationFactor: async () => {
        const { data } = await axios.post(`/${MODEL}/authfactor/enroll`)
        return data
    },
    verifyUserAuthenticationFactor: async (verificationCode: string) => {
        const { data } = await axios.post(`/${MODEL}/authfactor/verify`, { verificationCode })
        return data
    },
    createIban: async (accountId: string) => {
        const { data } = await axios.post(`/${MODEL}/iban`, { accountId })
        return data
    },
}
